import useFetchProductData from '../../hooks/ useFetchProductData/ useFetchProductData';
import { ProductIdType } from '../../types';
import CardList from '../CardList/CardList';

type AppProps = {
  productsId: ProductIdType[];
  isTwoItems?: Boolean;
};

function App2({ productsId, isTwoItems }: AppProps) {
  const data = useFetchProductData(productsId);

  return (
    <div className="m-section">
      <div className="m-section__container _container">
        {data && <CardList products={data} isTwoItems={isTwoItems} />}
      </div>
    </div>
  );
}

export default App2;
